import { $toast } from "vuetify-snackbar-toast";

export default function $handleError(error) {
  if (!error.message.includes("Unauthenticated")) {
    if (error.errors && typeof error.errors === "object") {
      const errorMessages = Object.values(error.errors).flat();

      errorMessages.forEach((message) => {
        $toast.danger(message);
      });
    } else {
      $toast.danger(error.message);
    }
  }
}

export const handleErrorPlugin = (vue) => {
  vue.prototype.$handleError = $handleError;
};
